import React from "react";
import ImageWithTag from './ImageWithTag';

function Block3() {
  return (
    <>
      <div className="">
        <ImageWithTag />
        <div className="text-sm pt-2 font-medium text-black">Urban Kitchen with Granite Tops, Exposed Bulb Lights and Island</div>
      </div>
    </>
  );
}

export default Block3;
